var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "bxDiv",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "repair-container" },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片标签", prop: "imageId" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          maxlength: "150",
                          type: "text",
                          clearable: "",
                          placeholder: "请输入图片标签"
                        },
                        model: {
                          value: _vm.childData.imageId,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "imageId", $$v)
                          },
                          expression: "childData.imageId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片信息", prop: "imageInfo" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          maxlength: "150",
                          type: "text",
                          clearable: "",
                          placeholder: "请输入图片信息"
                        },
                        model: {
                          value: _vm.childData.imageInfo,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "imageInfo", $$v)
                          },
                          expression: "childData.imageInfo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "菜单名称", prop: "menuName" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          maxlength: "150",
                          type: "text",
                          clearable: "",
                          placeholder: "请输入菜单名称"
                        },
                        model: {
                          value: _vm.childData.menuName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "menuName", $$v)
                          },
                          expression: "childData.menuName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片类型", prop: "fileType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择图片类型"
                          },
                          model: {
                            value: _vm.childData.fileType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "fileType", $$v)
                            },
                            expression: "childData.fileType"
                          }
                        },
                        _vm._l(_vm.typeOptions, function(item) {
                          return _c("el-option", {
                            key: parseInt(item.dicValue),
                            attrs: {
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片路径" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          maxlength: "150",
                          type: "text",
                          clearable: "",
                          placeholder: "请输入图片路径"
                        },
                        model: {
                          value: _vm.childData.pageUrl,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "pageUrl", $$v)
                          },
                          expression: "childData.pageUrl"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "照片", prop: "files" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            name: "files",
                            "list-type": "picture-card",
                            headers: _vm.importHeaders,
                            "on-success": _vm.handleSuccess,
                            action: _vm.uploadUrl,
                            "on-preview": _vm.handlePreview,
                            "on-remove": _vm.handleRemove,
                            "before-remove": _vm.beforeRemove,
                            "before-upload": _vm.beforeUpload,
                            limit: 1,
                            "on-exceed": _vm.handleExceed,
                            "file-list": _vm.files
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            visible: _vm.dialogVisible,
                            "append-to-body": true,
                            title: "预览"
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.dialogVisible = $event
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.dialogImageUrl,
                              alt: ""
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }